import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=32b712f3"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=32b712f3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports